import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { NotificationService } from '@notification/service';
import { Clipboard } from '@angular/cdk/clipboard';
import { TemplateService } from '@modules/service-request-template/services/template/template.service';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { splitTextIntoParagraphs } from '@helpers/text.helper';

@Component({
  selector: 'app-template-text-dialog',
  templateUrl: './template-text-dialog.component.html',
  styleUrls: ['./template-text-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemplateTextDialogComponent implements OnInit {
  paragraphs: string[] | null = null;
  rawTemplateText: string | null = null;

  constructor(
    private readonly notificationService: NotificationService,
    private readonly clipboard: Clipboard,
    private readonly templateService: TemplateService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) private readonly dialogData: { templateId: string },
  ) {}

  ngOnInit(): void {
    this.getTemplateText(this.dialogData.templateId);
  }

  protected copyToClipboard(): void {
    this.clipboard.copy(this.rawTemplateText);
    this.notificationService.info('Template text copied to clipboard!');
  }

  private getTemplateText(templateId: string): void {
    this.templateService.getTemplateById(templateId).subscribe((response) => {
      this.paragraphs = splitTextIntoParagraphs(response.generatedText);
      this.rawTemplateText = response.generatedText;

      this.changeDetectorRef.markForCheck();
    });
  }
}
